import ModalSharedRegister from "./ModalSharedRegister";

export default ModalSharedRegister;